import React, { useState } from 'react';
import classnames from 'classnames';
import Router from 'components/Router/Router';
import { ClassNameMap } from '@material-ui/styles';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import { getFormValues, submit } from 'redux-form';
import selectors from 'store/selectors';
import Modal from 'components/Base/Modal/Modal';
import { BoxWrapper, Button } from 'components/Base';
import { makeStyles } from '@material-ui/core';
const { useHistory } = Router;

interface RouteType {
  path: string;
  value: string;
}

const useStyles = makeStyles({
  container: {
    margin: '2.5rem',
    width: '21.875rem'
  },
  btnContainer: {
    width: '100%',
    height: '100px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '2.5rem'
  },
  btn: {
    borderRadius: '50px',
    '& span': {
      color: '#0080BD'
    }
  }
});
interface BreadcrumbProps {
  routeData: RouteType;
  classes: ClassNameMap;
  isActive: number | boolean | null;
  isPortfolioBuilder: number | boolean | null;
  isRecommendedCrumb: number | boolean | null;
  isQuestionnaireOpen: number | boolean | null;
  link: string;
  index: number;
  dispatch: Function;
  currentIndex: number | null;
  isCurrentIndex: boolean;
  isImportingPolicies: Function;
  callback?: Function | null;
}

const Breadcrumb = ({
  routeData,
  classes,
  isActive,
  isPortfolioBuilder,
  isRecommendedCrumb,
  isQuestionnaireOpen,
  link,
  index,
  dispatch,
  currentIndex,
  isCurrentIndex,
  isImportingPolicies,
  callback = null
}: BreadcrumbProps) => {
  const [hovering, setHovering] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const breadcrumbClasses = useStyles();

  const submitRiskSummary = async (link: any) => {
    if (callback) {
      callback(link);
    }
    setTimeout(() => {
      dispatch(submit('riskProfile'));
    }, 0);
  };

  return (
    <React.Fragment>
      <div
        id={`breadcrumb-${routeData.value}`}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        style={{
          borderRadius:
            index === 0 ? '15px 0 0 15px' : index === 5 ? '0 15px 15px 0' : '0'
        }}
        key={routeData.path}
        onClick={() => {
          if (currentIndex === 0) {
            submitRiskSummary(link);
            return;
          }
          if (currentIndex === 1 && isImportingPolicies) {
            return setIsModalOpen(true);
          }
          history.push(link);
        }}
        className={classnames(
          classes.crumb,
          isActive && classes.active,
          isPortfolioBuilder && isRecommendedCrumb && classes.active,
          isQuestionnaireOpen && classes.active,
          hovering && classes.hovering,
          isCurrentIndex && classes.isCurrentIndex
        )}
      >
        {routeData.value}
      </div>
      <Modal isOpen={isModalOpen} closeModalFunc={() => setIsModalOpen(false)}>
        <BoxWrapper title="You still have incomplete policies to resolve!">
          <div className={breadcrumbClasses.container}>
            If you leave without resolving them any incomplete policies they
            will not be saved, are you sure you want to navigate away?
            <div className={breadcrumbClasses.btnContainer}>
              <Button
                key="No, go back"
                onClick={() => setIsModalOpen(false)}
                type="button"
              >
                No, go back
              </Button>
              <Button
                key="Yes, discard all changes"
                onClick={() => history.push(link)}
                className={breadcrumbClasses.btn}
                variant="text"
              >
                Yes, discard all changes
              </Button>
            </div>
          </div>
        </BoxWrapper>
      </Modal>
    </React.Fragment>
  );
};

export default compose(
  connect((state: any) => ({
    riskValues: getFormValues('riskProfile')(state),
    isImportingPolicies:
      selectors.importingPoliciesSelectors.isImportingPolicies(state)
  }))
)(Breadcrumb);
